<template>
  <div class="trRep-edit__area table">
    <div class="trRep-edit__select">
      <div class="row">
        <div class="small-12 font-bold">
          {{ $t('username') }} ({{ $t('general.emailAddress') }})
        </div>
      </div>
      <div class="row">
        <div class="small-4">
          <HKLSelect
            :options="candidateOpts"
            :showSearch="true"
            @select="addSelectedUser"
          />
        </div>
      </div>
    </div>
    <table>
      <thead>
        <tr>
          <th
            v-for="({ labelKey }, index) in headers"
            :key="index"
          >
            {{ $t(`table.header.${labelKey}`) }}
          </th>
          <th />
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(user, index) in selectedUsers"
          :key="user.id"
        >
          <td
            v-for="({ valueKey }) in headers"
            :key="`${valueKey}_${index}`"
          >
            {{ user[valueKey] | isEmptyValue }}
          </td>
          <td
            v-if="user.id !== currentUser.id"
          >
            <HKLDeleteIcon @click="() => preDeleteUser(user, index)" />
          </td>
        </tr>
      </tbody>
    </table>
    <HKLModal
      ref="delModalRef"
      @onOkClick="() => removeUser(pendingDelIndex)"
    >
      <template
        #title
      >
        {{ $t("hint.deleteTenancyRepresentative") }}
      </template>
    </HKLModal>
  </div>
</template>

<script>
import { computed, ref, unref, onMounted, watch } from 'vue-demi'
import lodash from 'lodash'
import { useStoreGetters } from '@/store/index'
import HKLDeleteIcon from '@/controls/Icon/HKLDeleteIcon.vue'
import HKLSelect from '@/controls/Select/HKLSelect.vue'
import { useRouteParamId } from '@/router/useRouter'
import { useRefModal } from '@/controls/Modal/modal.hook'
import HKLModal from '@/controls/Modal/HKLModal.vue'
import { useUpdateTrRepAccess, useActiveEngineers, useHeaderCols, useTrRepAccounts } from './hook'

export default {
  components: {
    HKLModal,
    HKLDeleteIcon,
    HKLSelect,
  },
  setup (__, { emit }) {
    const { currentUser } = useStoreGetters('user', ['currentUser'])
    const headers = useHeaderCols()
    const { activeEngineersOpts } = useActiveEngineers()
    const selectedUsers = ref([])
    const tenancyId = useRouteParamId()
    const { accounts: currentAccounts } = useTrRepAccounts(tenancyId)
    const disabledIds = computed(() => {
      const result = unref(selectedUsers).map(item => item.id)
      return result.concat(unref(currentUser).id)
    })
    const candidateOpts = computed(() => {
      return unref(activeEngineersOpts).filter(opt => {
        return !unref(disabledIds).includes(opt.value.id)
      })
        .sort((a, b) => a.name.localeCompare(b.name))
    })
    const addSelectedUser = (user) => {
      const parsedUser = JSON.parse(user)
      selectedUsers.value.push(parsedUser)
    }
    const removeUser = (sIndex) => {
      selectedUsers.value.splice(sIndex, 1)
    }
    const pendingDelIndex = ref(null)
    const { open: openDelModal, modal: delModalRef } = useRefModal()
    const preDeleteUser = (item, index) => {
      const hasInvited = lodash.get(item, 'rawInviteAt')
      if (hasInvited) {
        pendingDelIndex.value = index
        openDelModal()
      } else {
        removeUser(index)
      }
    }
    onMounted(() => {
      selectedUsers.value.push(...currentAccounts.value)
    })
    watch(selectedUsers, () => {
      emit('update:trReps', unref(selectedUsers))
    })
    return {
      currentUser,
      delModalRef,
      preDeleteUser,
      pendingDelIndex,
      currentAccounts,
      candidateOpts,
      activeEngineersOpts,
      hasUpdateTrRepAccess: useUpdateTrRepAccess,
      headers,
      selectedUsers,
      addSelectedUser,
      removeUser,
    }
  },
}
</script>
